import { Quote } from "lucide-react";
import { useContent } from "@/content/ContentContext";
import { Eyebrow, Reveal } from "./Reveal";

const QUOTES = [
    {
        quote:
            "When a customer hands me an AdvantaShield card, I don't brace for a fight. The claim is approved at my counter, at my door rate. That's unheard of in this business.",
        name: "M. Alvarez",
        role: "Service Director, Franchise Dealer Group",
    },
    {
        quote:
            "We've stopped accepting most third-party contracts outright. AdvantaShield is the one exception — because dealers built it for how we actually work.",
        name: "D. Whitfield",
        role: "Service Advisor, 14 years on the lane",
    },
    {
        quote:
            "I pay less per month than my streaming bundle. When my A/C died in July, my own dealer fixed it and AdvantaShield picked up the bill. I never made a phone call.",
        name: "R. Okafor",
        role: "Advantage Plus subscriber",
    },
];

export const Testimonials = () => {
    const content = useContent();

    return (
    <section
        data-testid="testimonials-section"
        className="bg-[#0C1019] py-24 md:py-36"
    >
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <Eyebrow>{content.testimonials_eyebrow}</Eyebrow>
                <h2 className="mt-5 max-w-3xl font-display text-3xl font-bold leading-[1.1] tracking-tight text-white sm:text-4xl lg:text-5xl">
                    {content.testimonials_heading_a}{" "}
                    <span className="text-sky-400">{content.testimonials_heading_b}</span>
                </h2>
            </Reveal>

            <div className="mt-14 grid grid-cols-1 gap-6 md:mt-20 md:grid-cols-3 lg:gap-8">
                {QUOTES.map((q, i) => (
                    <Reveal key={q.name} delay={i * 0.1} className="h-full">
                        <figure
                            data-testid={`testimonial-card-${i}`}
                            className="flex h-full flex-col rounded-3xl border border-white/10 bg-[#121722] p-8 transition-[border-color,transform] duration-500 hover:-translate-y-2 hover:border-sky-400/30"
                        >
                            <Quote className="h-7 w-7 text-sky-400/70" />
                            <blockquote className="mt-6 flex-1 text-base leading-relaxed text-slate-300">
                                "{q.quote}"
                            </blockquote>
                            <figcaption className="mt-8 border-t border-white/10 pt-6">
                                <p className="font-display text-sm font-semibold text-white">
                                    {q.name}
                                </p>
                                <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-500">
                                    {q.role}
                                </p>
                            </figcaption>
                        </figure>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
    );
};
